import { Component, OnInit } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pii-share-asstnt',
  templateUrl: './pii-share-asstnt.component.html',
  styleUrls: ['./pii-share-asstnt.component.css']
})
export class PiiShareAsstntComponent implements OnInit {

  @Output() emitter:EventEmitter<any>=new EventEmitter<any>();
  @Output() submits = new EventEmitter();
  @Input() display: boolean = false;
  constructor() { }

  ngOnInit() {
  }
  submit() {
    // this.emitter.next("Confirm");
    this.submits.emit( true );
    //this._router.navigateByUrl("/"+AppRouteConstants.AST_SRCH_PRFX_MDUL+"/assistSearchPostConfirm");
    // this.activeModal.close();
   
    
  }
  
  cancel() {
    // this.emitter.next("Cancel");
    // this.activeModal.close();
    this.submits.emit( false );
  }
}
